import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { IWGSharedService } from '../../shared/services/shared.service';

@Injectable({
  'providedIn': 'root'
})
export class NavbarService {
  visible: boolean;
  activeMenu: string;
  activeModuleSubject = new Subject<any>();
  activeModuleSubject$:Observable<any> = this.activeModuleSubject.asObservable();

    constructor(private sharedService: IWGSharedService) { this.visible = false; };

  hide = () => { this.visible = false; };

    show = (isEmbed = false) => {           
      
        this.visible = isEmbed === false;
   
   };

  toggle = () => { this.visible = !this.visible; };

  setActiveMenu(currPageName: string): void {
    this.activeMenu = currPageName;
  }

  setActiveModuleMenu(menu:any){
    this.activeModuleSubject.next(menu);
  }
  resetActiveModuleMenu() {
    this.activeModuleSubject.next('');
  }

}